export const config = {
    // serverUrl: "http://104.200.18.127/geoserver/ows"
    serverUrl: "https://www.dobenergy.com/geoserver/ows",
    pipelineLayerUrl: "https://www.dobenergy.com/geoserver/gwc/service/tms/1.0.0/jwn:pipeline@EPSG:900913@png/{z}/{x}/{-y}.png",
    provinceLayerUrl: "https://www.dobenergy.com/geoserver/gwc/service/tms/1.0.0/jwn:canada_bounds@EPSG:900913@png/{z}/{x}/{-y}.png"
}



// WEBPACK FOOTER //
// ./src/config.js